<!--  -->
<template>
  <div class='update-page'>
    <nav-title title="商品信息"></nav-title>
    <main>
      <van-form ref="form">
        <div class="form-item">
          <span>商品名称</span>
          <van-field
            v-model="dataForm.goods_name"
            readonly
          />
        </div>
        <div class="form-item images">
          <span>商品分类</span>
          <span v-html="dataForm.category_name"></span>
        </div>
        <div class="form-item">
          <span>商品编码</span>
          <van-field
            readonly
            v-model="dataForm.goods_no"
          />
        </div>
        <div class="form-item">
          <span>商品价格</span>
          <van-field
            readonly
            v-model="dataForm.goods_price"
          />
        </div>
        <div class="form-item images">
          <span>商品图片</span>
          <main>
            <template v-if="dataForm.goods_img.length > 0">
              <div class="image" v-for="(item, index) in dataForm.goods_img" :key="index" @click="handleImg(index)">
                <img :src="item" alt="">
              </div>
            </template>
          </main>
        </div>
        <div class="form-item">
          <span>当前库存</span>
          <van-field
            readonly
            v-model="dataForm.stock_num"
          />
        </div>
        <div class="form-item">
          <span>仓储位置</span>
          <van-field
            readonly
            v-model="dataForm.goods_address"
          />
        </div>
        <div class="form-item">
          <span>入库时间</span>
          <van-field
            readonly
            v-model="dataForm.entry_time"
          />
        </div>
        <div class="form-item">
          <span>入库人</span>
          <van-field
            readonly
            v-model="dataForm.admin_name"
          />
        </div>
        <div class="form-item textarea">
          <span>商品详情</span>
          <p v-html="dataForm.content"></p>
        </div>
      </van-form>
    </main>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';

export default {
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      dataForm: {
        goods_name: '',
        category_id: '',
        goods_price: '',
        images: [],
        stock_num: '',
        goods_address: '',
        content: '',
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getInfo()
  },
  mounted() {
    
  },
  beforeDestroy() {
    
  },
  //方法集合
  methods: {
    // 获取详情
    getInfo () {
      this.$http({
        method: 'post',
        data: {
          c: 'goods/goods_detail',
          goods_id: this.$route.query.goods_id
        }
      }).then(res => {
        if (res.code == 200) {
          this.dataForm = res.data
        } else {
          this.$toast.fail(res.message || '详情获取失败')
        }
      })
    },
    handleImg (i) {
      ImagePreview({
        images: this.dataForm.goods_img,
        startPosition: i
      });
    },
  },
}
</script>

<style lang='less' scoped>
.update-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #FAFAFA;
  > main {
    flex: 1;
    padding: 15px;
    overflow: hidden;
    background-color: #fff;
    overflow-y: auto;
    .form-item {
      overflow: hidden;
      display: flex;
      align-items: center;
      padding-bottom: 15px;
      border-bottom: 0.5px solid rgba(229, 229, 229, 0.51);
      margin-bottom: 15px;
      &:last-child {
        border-bottom: 0px;
        margin-bottom: 0px;
        padding-bottom: 0px;
      }
      > span {
        width: 99px;
        font-size: 16px;
        display: block;
      }
      .van-cell  {
        flex: 1;
        overflow: visible;
        background-color: transparent;
        /deep/ .van-field__error-message {
          position: absolute;
          top: 100%;
          left: 0;
        }
      }
      > main {
        display: flex;
        gap: 5px 10px;
        flex-wrap: wrap;
        margin-top: 7px;
        .image {
          width: 98px;
          height: 98px;
          border-radius: 6px;
          overflow: visible;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #FAFAFA;
          position: relative;
          > img {
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
    }
    .textarea {
      flex-wrap: wrap;
      > p {
        width: 100%;
        min-height: 160px;
        border-radius: 6px;
        border: 1px solid #F1F1F2;
        padding: 8px 12px;
        margin-top: 10px;
        overflow-x: hidden;
        /deep/ img {
          max-width: 100%;
        }
      }
    }
    .images {
      align-items: flex-start;
    }
  }
}
</style>